import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class StartJobEntity {
  region?: RegionMiniEntity
  fromDate?: string
  toDate?: string
}
